var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-testid": _vm.testId } }, [
    _c("a", {
      staticClass: "anchor-highlight",
      attrs: { name: "search-highlight" }
    }),
    _vm._v(" "),
    _vm.showHighlight
      ? _c(
          "div",
          { staticClass: "highlight" },
          [
            _c("transition", { attrs: { name: "alert-reveal" } }, [
              _vm.showHighlightAlert
                ? _c("div", { staticClass: "alert" }, [
                    _c("p", [
                      _vm._v("Search for the topic you'd like to learn here")
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-link",
                        on: { click: _vm.handleHideHighlight }
                      },
                      [_vm._v("Got it!")]
                    )
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "search",
        class: { "header-search-container": _vm.inHeader },
        attrs: { name: "search" },
        on: {
          click: function($event) {
            $event.stopPropagation()
          }
        }
      },
      [
        _c("SearchInput", {
          key: _vm.componentKey,
          ref: "searchInput",
          attrs: { "in-header": _vm.inHeader, testIdPrefix: _vm.testId },
          on: {
            "update-search-query": _vm.useCustomQuery,
            focus: _vm.startSearching
          }
        }),
        _vm._v(" "),
        _vm.activelySearching
          ? _c(
              "div",
              {
                ref: "searchDropdown",
                staticClass: "search-dropdown",
                class: { "in-header": _vm.inHeader },
                attrs: { "data-testid": _vm.testId + "_search_dropdown" },
                on: { wheel: _vm.onWheel }
              },
              [
                _vm.showSearchResults
                  ? _c("SearchQueryResults", {
                      key: _vm.componentKey,
                      attrs: {
                        "in-header": _vm.inHeader,
                        "is-staff-user": _vm.isStaffUser,
                        mobile: _vm.mobile,
                        testIdPrefix: _vm.testId
                      }
                    })
                  : !_vm.inHeader
                  ? _c("SuggestedQueries", {
                      key: _vm.componentKey,
                      attrs: { mobile: _vm.mobile, testIdPrefix: _vm.testId },
                      on: { "update-search-query": _vm.useSuggestedQuery }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }